/** Current-user profile API (web) — /api/v1/users/me. Email + role are read-only. */
import { apiClient } from '../../../services/apiClient';

export interface CurrentUserDto {
  id: string;
  email: string;
  name: string;
  phone?: string | null;
  language?: string | null;
  role: string;
  organizationId: string;
}

export interface UpdateCurrentUserRequest {
  name?: string;
  phone?: string | null;
  language?: string;
}

export const getCurrentUser = () => apiClient.get<CurrentUserDto>('/api/v1/users/me');

export const updateCurrentUser = (data: UpdateCurrentUserRequest) =>
  apiClient.patch<CurrentUserDto>('/api/v1/users/me', data);
